import { render, staticRenderFns } from "./ReportSubTitle.vue?vue&type=template&id=56658402&"
import script from "./ReportSubTitle.vue?vue&type=script&lang=js&"
export * from "./ReportSubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports